import httpRequest from "../../../infrastructure/httphelper";
import sharedGlobals from "../../../sharedglobals";
import securitySrevice  from '../../../services/securityservice'

class ReportEngineService {
  constructor() {}

  getReports(input) {
    let url =
      sharedGlobals.appUrls.reportManagerApiUrl +
      "api/ReportEngineService/GetReports";
    return httpRequest({
      url: url,
      method: "POST",
      params: input,
    });
  }
  getReports2(urlParams,uiParams) {
    let url =
      sharedGlobals.appUrls.reportManagerApiUrl +
      "api/ReportEngineService/GetReports2";
    let uiParmsMapped=[];
    if(uiParams){
      Object.keys(uiParams).forEach(key=>{
          uiParmsMapped.push(
            {
              Name: key,
              Value:""+ uiParams[key]
            }
          );
      });
    }
    return httpRequest({
      url: url,
      method: "POST",
      params: urlParams,
      data:uiParmsMapped
    });
  }
  getReportParams(reportId,uiParams) {
    let param = {
      reportId: reportId,
    };
    let uiParmsMapped=[];
    if(uiParams){
      Object.keys(uiParams).forEach(key=>{
          uiParmsMapped.push(
            {
              Name: key,
              Value:""+ uiParams[key]
            }
          );
      });
    }
    let url =
      sharedGlobals.appUrls.reportManagerApiUrl +
      "api/ReportEngineService/GetReportParams";
    return httpRequest({
      url: url,
      method: "POST",
      params: param,
      data:uiParmsMapped
    });
  }
  getReportParamValue(reportId, paramId, reportContext) {
    let param = {
      reportId: reportId,
      paramId: paramId,
    };
    let url =
      sharedGlobals.appUrls.reportManagerApiUrl +
      "api/ReportEngineService/GetReportParamValue";
    return httpRequest({
      url: url,
      method: "POST",
      params: param,
      data: reportContext
    });
  }
  getReportUrl(reportContext) {
    const url = sharedGlobals.appUrls.reportManagerApiUrl +"api/ReportEngineService/GetReportUrl";    
    return httpRequest({
      url: url,
      method: 'POST',
      data: reportContext,
    });
  
  }
}

let instance = new ReportEngineService();
export default instance;
